import template from './imageDetail.html';
import controller from './imageDetail.controller';
import './imageDetail.scss';

let imageDetailComponent = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  template,
  controller,
  controllerAs: "vm"
};

export default imageDetailComponent;



// WEBPACK FOOTER //
// ./client/app/common/imageDetail/imageDetail.component.js